export default __webpack_public_path__ + "static/media/User-icon.34bbe557.svg";